import { getLiveSectionColClass } from '../../../shared/components/dashboard/dashboard-layout-editor.helpers';
import {
  ARRANGMENT_CRON_DEFAULT_COL_SPAN,
  ArrangmentCronSectionLayoutItem,
} from './arrangment-cron-layout.catalog';

export type SectionLayoutMap = Record<string, ArrangmentCronSectionLayoutItem>;

export function showArrangmentSection(
  layout: SectionLayoutMap,
  sectionId: string,
): boolean {
  if (!layout || !Object.keys(layout).length) return true;
  return layout[sectionId]?.visible !== false;
}

export function arrangmentSectionOrder(
  layout: SectionLayoutMap,
  sectionId: string,
): number {
  return layout[sectionId]?.order ?? 999;
}

export function arrangmentSectionColClass(
  layout: SectionLayoutMap,
  sectionId: string,
): string {
  const span =
    layout[sectionId]?.colSpan ??
    ARRANGMENT_CRON_DEFAULT_COL_SPAN[sectionId] ??
    12;
  return getLiveSectionColClass(span);
}
